import type { Listing } from '@thevillages/schemas';

import type { ListingsService } from '../listings';

export function PendingSales(
  this: ListingsService,
  listing: Listing,
  currentValue: boolean,
): boolean {
  // If no value is set, do not affect the filter.
  if (this.filteringService.includePendingSales()) {
    return currentValue;
  }

  // Determine if the listing matches the filter.
  if (listing.pending) {
    return false;
  }

  // If the listing does not match the filter, do not affect the filter.
  return currentValue;
}
